"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEO = exports.VIDEO = "Video";
var IMAGE = exports.IMAGE = "Image";


//////////////////
// WEBPACK FOOTER
// ../~/sportinglife-react-common/lib/mediaTypes/index.js
// module id = 708
// module chunks = 0